
import React from 'react';
import SVGComponent from '../../components/SVG/SVGComponent';
import {
  MENU_ROUTES, MENU_ICONS, MENU_TYPES, SVG_ICONS,
} from '../../constants';

const MenuItem = ({
  children, isSelectedMenu, className, classMenu, onClickMenu, label, route,
}) => (
  <div
    className={[className,
      isSelectedMenu ? 'open' : ''].join(' ')}
    key={route}
  >
    <div
      className={classMenu}
      onClick={onClickMenu}
    >
      {MENU_ICONS[route] && (className.includes(MENU_TYPES.HOME_MENU)
        || MENU_ROUTES.includes(route)) && (
        <SVGComponent
          className="icon-xs  m-r-10"
          src={`${SVG_ICONS.homeIcons}#${MENU_ICONS[route]}`}
        />
      )}
      <span>{label}</span>
    </div>
    {children}
  </div>
);

export default MenuItem;
